import React from "react";
import {Glyphicon, OverlayTrigger, Tooltip} from "react-bootstrap";

class HelpHintButton extends React.Component {
	render() {
		const {children}  = this.props;
		const placement = this.props.placement || 'top';
		const tooltipId = Math.random();

		const tooltip = <Tooltip id={tooltipId}>{children}</Tooltip>;

		return (
			<span>
				{' '}
				<OverlayTrigger placement={placement} overlay={tooltip}>
					<Glyphicon glyph='question-sign' />
				</OverlayTrigger>
			</span>
		);
	}
}

export default HelpHintButton;
